import React, { FC, ReactElement } from 'react';
import { trans } from '../helpers/helperFunctions';
import { IIceHockeyMatchLiveScore } from '../interfaces/interfaces';

type PeriodScoreProps = {
  score: IIceHockeyMatchLiveScore;
  gameEnded: boolean;
};

const ScorePerPeriod: FC<PeriodScoreProps> = ({
  score,
  gameEnded
}: PeriodScoreProps): ReactElement => {
  const isGoldenGoal =
    score?.extraTime && (!!Number(score.extraTime.home) || !!Number(score.extraTime.away));

  return (
    <div className="period-score">
      (
      <span>
        {score.period1 ? score.period1.home : '-'}:{score.period1 ? score.period1.away : '-'}
      </span>
      <span>
        {score.period2 ? score.period2.home : '-'}:{score.period2 ? score.period2.away : '-'}
      </span>
      <span>
        {score.period3 ? score.period3.home : '-'}:{score.period3 ? score.period3.away : '-'}
      </span>
      {score?.extraTime && (
        <span>
          {score.extraTime.home}:{score.extraTime.away}
        </span>
      )}
      )
      {gameEnded && score.extraTime && (
        <div className="period-score-overtime">
          {isGoldenGoal ? trans('overtime-short') : trans('penalties-short')}
        </div>
      )}
    </div>
  );
};

export default ScorePerPeriod;
